/* Name:Chaitali Khachane
   Description:This page will contain some detail information about Domain Data , this is outer structute of 
   single domain, in this page their are various table tab like master data,supply data, R&D....
*/
import React, { Fragment, useEffect, useState } from "react";
import { TabMenu } from "primereact/tabmenu";
import SupplyDomain from "./supplyDomain";
import BreadCrumbComp from "../../component/breadCrumb/breadCrump";
import MasterDataDomain from "./masterDataDomain";
import { useSelector } from "react-redux";
import DemandDomain from "./demandDomain";
import RNDDomain from "./rNDDomain";
import FinanceDomain from "./financeDomain";
import PNODomain from "./pNODomain";
function DataDomainPage() {
   const { steppersData } = useSelector((state) => state.crumbs)
   const {formData} = useSelector((state)=>state.dataDomain)
   const [activeIndex, setActiveIndex] = useState(
     formData.domainActiveIndex.value
   );

   const items = [
      // {
      //    id: 0,
      //    label: <span style={{ paddingLeft: "10px" }}>MASTER DATA</span>,
      //    element: <MasterDataDomain />
      // },
      // { id: 1, label: 'SUPPLY', element: <SupplyDomain /> },
      { id: 0, label: 'SALES', element: <DemandDomain/> },
      { id: 1, label: 'MARKETING', element: <RNDDomain/> },
   ];
  
  //this method will return the component of the selected tab
   const getElement = () => {
      return items.filter((val) => val.id === activeIndex)[0].element
   }
   // this hook will used to call APIs
   useEffect(() => {
    
   }, [])

   return <Fragment>
      <BreadCrumbComp items={steppersData.dataDomainSteps}/>
      <div className="card">
         <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
      </div>
      {getElement()}
   </Fragment>
}

export default DataDomainPage
